import { GeneralInfoEditCameraTabEditMode } from "../GeneralInfoEditCameraTabEditMode";
import { ConnectionsTabEditMode } from "../ConnectionsTabEditMode";
import { NotificationsTabEditMode } from "../NotificationsTabEditMode";
import { ProductsTabEditMode } from "../ProductsTabEditMode";
import { Dispatcher } from "../../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import ErrorBoundary from "../../../../ErrorBoundary";
import { StreamParametersTabEditMode } from "../StreamParametersTabEditMode";
import { AlertSettingsTabEditMode } from "../AlertSettingsTabEditMode";
import { SlicingTabEditMode } from "../SlicingTabEditMode";
import { VlmTabEditMode } from "../VlmTabEditMode";

export const handleEditInfoButtonClick = (
  setEditMode: any,
  clickedTab: any,
  setActiveTab: any,
  siteInfo: any,
  cameraGeneralInfo: any,
  setCameraGeneralInfo: any,
  setPatchObject: any,
  setGeneralInfoChangesMade: any,
  setActiveChangeMade: any,
  immixAlerts: any,
  diceAlerts: any,
  sureviewAlerts: any,
  activeProducts: any,
  cameraWebhookData: any,
  productsData: any,
  setProductsData: Dispatcher<any>,
  allTabsOpen: boolean,
  setAllTabsOpen: Dispatcher<boolean>,
  setBackupProductsData: any,
  sentinelAlerts: any,
  boldAlerts: any,
  patriotAlerts: any,
  softguardAlerts: any,
  streamParametersData: any,
  streamParametersPatchObject: any,
  setStreamParametersPatchObject: any,
  setStreamParametersChangesMade: any,
  setEditStreamWebhookDialogOpen: any,
  immixAlertsOnCamera: boolean,
  diceAlertsOnCamera: boolean,
  sureViewAlertsOnCamera: boolean,
  webhooksAlertsOnCamera: boolean,
  sentinelAlertsOnCamera: boolean,
  boldAlertsOnCamera: boolean,
  patriotAlertsOnCamera: boolean,
  softguardAlertsOnCamera: boolean,
  evalinkAlertsOnCamera: boolean,
  setAddStreamWebhookDialogOpen: Dispatcher<boolean>
) => {
  setEditMode(true);
  if (clickedTab === "one") {
    setActiveTab(
      <ErrorBoundary>
        <GeneralInfoEditCameraTabEditMode
          siteInfo={siteInfo}
          cameraGeneralInfo={cameraGeneralInfo}
          setCameraGeneralInfo={setCameraGeneralInfo}
          setPatchObject={setPatchObject}
          setGeneralInfoChangesMade={setGeneralInfoChangesMade}
          setActiveChangeMade={setActiveChangeMade}
        />
      </ErrorBoundary>
    );
  } else if (clickedTab === "two") {
    setActiveTab(
      <ErrorBoundary>
        <ConnectionsTabEditMode
          cameraGeneralInfo={cameraGeneralInfo}
          setCameraGeneralInfo={setCameraGeneralInfo}
          setPatchObject={setPatchObject}
          setGeneralInfoChangesMade={setGeneralInfoChangesMade}
        />
      </ErrorBoundary>
    );
  } else if (clickedTab === "three") {
    setActiveTab(
      <ErrorBoundary>
        <NotificationsTabEditMode
          cameraGeneralInfo={cameraGeneralInfo}
          setCameraGeneralInfo={setCameraGeneralInfo}
          setPatchObject={setPatchObject}
          setGeneralInfoChangesMade={setGeneralInfoChangesMade}
        />
      </ErrorBoundary>
    );
  } else if (clickedTab === "four") {
    setActiveTab(
      <ErrorBoundary>
        <ProductsTabEditMode
          activeProducts={activeProducts}
          setPatchObject={setPatchObject}
          setGeneralInfoChangesMade={setGeneralInfoChangesMade}
          cameraGeneralInfo={cameraGeneralInfo}
          productsData={productsData}
          setProductsData={setProductsData}
          allTabsOpen={allTabsOpen}
          setAllTabsOpen={setAllTabsOpen}
          setBackupProductsData={setBackupProductsData}
          siteInfo={siteInfo}
        />
      </ErrorBoundary>
    );
  } else if (clickedTab === "fifteen") {
    setActiveTab(
      <ErrorBoundary>
        <StreamParametersTabEditMode
          streamParametersData={streamParametersData}
          streamParametersPatchObject={streamParametersPatchObject}
          setStreamParametersPatchObject={setStreamParametersPatchObject}
          setStreamParametersChangesMade={setStreamParametersChangesMade}
          siteInfo={siteInfo}
        />
      </ErrorBoundary>
    );
  } else if (clickedTab === "sixteen") {
    localStorage.setItem(
      "softguardAlertsBackup",
      JSON.stringify(softguardAlerts)
    );
    setActiveTab(
      <ErrorBoundary>
        <AlertSettingsTabEditMode
          immixAlerts={immixAlerts}
          diceAlerts={diceAlerts}
          sureviewAlerts={sureviewAlerts}
          setEditStreamWebhookDialogOpen={setEditStreamWebhookDialogOpen}
          sentinelAlerts={sentinelAlerts}
          boldAlerts={boldAlerts}
          patriotAlerts={patriotAlerts}
          softguardAlerts={softguardAlerts}
          immixAlertsOnCamera={immixAlertsOnCamera}
          diceAlertsOnCamera={diceAlertsOnCamera}
          sureViewAlertsOnCamera={sureViewAlertsOnCamera}
          siteInfo={siteInfo}
          webhooksAlertsOnCamera={webhooksAlertsOnCamera}
          sentinelAlertsOnCamera={sentinelAlertsOnCamera}
          boldAlertsOnCamera={boldAlertsOnCamera}
          patriotAlertsOnCamera={patriotAlertsOnCamera}
          softguardAlertsOnCamera={softguardAlertsOnCamera}
          evalinkAlertsOnCamera={evalinkAlertsOnCamera}
          cameraGeneralInfo={cameraGeneralInfo}
          setPatchObject={setPatchObject}
          setGeneralInfoChangesMade={setGeneralInfoChangesMade}
          setAddStreamWebhookDialogOpen={setAddStreamWebhookDialogOpen}
        />
      </ErrorBoundary>
    );
  } else if (clickedTab === "five") {
    setActiveTab(
      <ErrorBoundary>
        <SlicingTabEditMode />
      </ErrorBoundary>
    );
  } else if (clickedTab === "seventeen") {
    setActiveTab(
      <ErrorBoundary>
        <VlmTabEditMode />
      </ErrorBoundary>
    );
  }
};
